(function () {
  'use strict';
  const quizzes = {
    'best-tricks-to-remove-gum-from-you-clothing-guaranteed': {
      title: 'Quick question',
      questions: [{ question: 'Why freeze gum before removing it from clothing?', choices: ['To change the fabric color', 'To harden the gum so it is easier to lift off', 'To make the gum stickier', 'To replace washing the garment'], answer: 1, explanation: 'Freezing firms up the gum, making it easier to gently scrape away.' }]
    },
    'lint-roller-types-uses': {
      title: 'Quick question',
      questions: [{ question: 'What should you do when a sticky lint-roller sheet is full?', choices: ['Add soap to the sheet', 'Press harder on the fabric', 'Peel it off to reveal a fresh sheet', 'Put the roller in the freezer'], answer: 2, explanation: 'Peeling away the used sheet exposes fresh adhesive for picking up lint and pet hair.' }]
    },
    'best-spin-mop-bucket': {
      title: 'Quick question',
      questions: [{ question: 'What does a spin mop’s wringing mechanism help you control?', choices: ['How much water stays in the mop head', 'The floor’s color', 'The room’s temperature', 'How much cleaner is in the bottle'], answer: 0, explanation: 'The wringer removes excess water so you can adjust the mop’s dampness.' }]
    },
    'homemade-mop-solution-recipes': {
      title: 'Quick question',
      questions: [{ question: 'What should you do before using a new homemade floor cleaner?', choices: ['Use it on every floor immediately', 'Double every ingredient', 'Skip checking the floor type', 'Test it on a small, hidden area'], answer: 3, explanation: 'Check your floor’s care instructions and spot-test a new cleaner before using it widely.' }]
    },
    'decoding-pure-play-ecommerce-what-it-is-and-how-it-drives-onlineonly-retail-success': {
      title: 'Quick question',
      questions: [{ question: 'What makes a retailer “pure play” e-commerce?', choices: ['It sells only in shopping malls', 'It sells exclusively online without physical storefronts', 'It sells one product color', 'It accepts only cash'], answer: 1, explanation: 'Pure play retailers operate through digital channels rather than physical retail stores.' }]
    },
    'the-halo-effect-advantage-how-smart-retailers-drive-sales-through-perception-power': {
      title: 'Quick question',
      questions: [{ question: 'What is the halo effect in retail?', choices: ['Discounting every item', 'Adding lights around a store sign', 'A positive impression of one product improving perceptions of the brand', 'Replacing all product packaging'], answer: 2, explanation: 'A strong impression of one product or experience can carry over to the rest of the brand.' }]
    },
    'retail-lighting-tips-to-encourage-sales-through-lights': {
      title: 'Quick question',
      questions: [{ question: 'Which type of lighting highlights particular products?', choices: ['Accent lighting', 'Emergency lighting', 'Street lighting', 'Lighting only the stockroom'], answer: 0, explanation: 'Accent lighting acts like a spotlight, drawing shoppers’ attention to selected products.' }]
    },
    'maximizing-retail-revenue-in-2026-strategic-use-of-clip-strip-pop-displays-to-drive-sales-and-engagement': {
      title: 'Quick question',
      questions: [{ question: 'Where can a clip strip encourage useful add-on purchases?', choices: ['Behind a closed stockroom door', 'Away from shopper traffic', 'Hidden beneath a counter', 'Near complementary products in a busy aisle'], answer: 3, explanation: 'Placing related items together in visible, busy areas helps shoppers notice relevant add-ons.' }]
    },
    'what-put-in-mop-bucket': {
      title: 'Quick question',
      questions: [
        { question: 'What should you do before mopping?', choices: ['Add extra soap', 'Sweep or vacuum loose dirt', 'Soak the whole floor', 'Skip the preparation'], answer: 1, explanation: 'Remove loose dirt first so your mop does not spread debris around.' },
      ]
    },
    'cutting-out-the-middleman-understanding-disintermediation-and-its-impact-on-modern-business': {
      title: 'Quick question',
      questions: [
        { question: 'What does disintermediation mean?', choices: ['Adding more distributors', 'Removing intermediaries from a transaction', 'Changing a brand name', 'Moving products to a new shelf'], answer: 1, explanation: 'Disintermediation creates a more direct relationship between producer and buyer.' },
      ]
    }
  };
  const defaults = {
    like: 'Like', liked: 'Liked', follow: 'Follow', share: 'Share', add: 'Add Us',
    google: 'Add as a preferred source on Google', newsletter: 'Get news and offers by email',
    facebook: 'Facebook', instagram: 'Instagram', linkedin: 'LinkedIn', copy: 'Copy link',
    email: 'Email', deviceLiked: 'Liked on this device.', deviceUnliked: 'Like removed on this device.',
    temporaryLike: 'Your choice is saved for this visit; browser storage is unavailable.',
    copied: 'Link copied.', copyManual: 'Select and copy the article link below.',
    newsletterHelp: 'Use the newsletter form to sign up for news and offers.',
    newsletterMissing: 'The newsletter form is unavailable on this page. Please use the site’s newsletter signup.',
    next: 'Next question', results: 'See results', restart: 'Try again', correct: 'Correct!',
    incorrect: 'Not quite.', question: 'Question {current} of {total}',
    score: 'You scored {score} out of {total}.', complete: 'Quiz complete',
    recap: 'Review your answers', progress: 'Quiz progress', link: 'Article link',
    shareDevice: 'More sharing options', perfect: 'Great work! You got every answer right.',
    finished: 'Thanks for taking the quiz. Review the explanations below or try again.'
  };
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    let config = {};
    try { config = JSON.parse(root.dataset.config || '{}'); } catch (_) {}
    const t = Object.assign({}, defaults, config.labels || {});
    const newsletterPanel = root.querySelector('.be-newsletter-panel');
    if (newsletterPanel && newsletterPanel.querySelector('.errors, .be-newsletter-success')) newsletterPanel.hidden = false;
    const path = location.pathname.replace(/\/+$/, '');
    const slug = path.split('/').pop();
    const quiz = quizzes[slug];
    const canonical = document.querySelector('link[rel="canonical"]');
    const url = canonical ? canonical.href : location.origin + path;
    const titleNode = document.querySelector('h1');
    const title = titleNode ? titleNode.textContent.trim() : document.title;
    const replace = (str, values) => str.replace(/\{(\w+)\}/g, (_, key) => String(values[key]));
    function element(tag, className, text) {
      const e = document.createElement(tag);
      if (className) e.className = className;
      if (text !== undefined) e.textContent = text;
      return e;
    }
    function button(label, className) {
      const b = element('button', className, label);
      b.type = 'button';
      return b;
    }
    function link(label, href) {
      const a = element('a', 'be-link', label);
      a.href = href;
      if (href.startsWith('https://')) { a.target = '_blank'; a.rel = 'noopener noreferrer'; }
      return a;
    }
    const status = element('p', 'be-status');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    if (quiz) {
      const box = element('section', 'be-quiz');
      box.setAttribute('aria-label', quiz.title);
      const heading = element('h2', 'be-title', quiz.title);
      const content = element('div', 'be-quiz-content');
      box.append(heading, content);
      root.append(box);
      const q = quiz.questions[0];
      const question = element('h3', 'be-question', q.question);
      const grid = element('div', 'be-answers');
      const feedback = element('div', 'be-feedback');
      feedback.hidden = true;
      feedback.setAttribute('role', 'status');
      q.choices.forEach((choice, selected) => {
        const b = button('', 'be-answer');
        b.append(element('span', 'be-letter', String.fromCharCode(65 + selected)), element('span', '', choice));
        b.addEventListener('click', () => {
          const correct = selected === q.answer;
          Array.from(grid.children).forEach((option, j) => { option.disabled = true; if (j === q.answer) option.classList.add('is-correct'); });
          if (!correct) b.classList.add('is-incorrect');
          feedback.hidden = false;
          feedback.classList.add(correct ? 'is-correct' : 'is-incorrect');
          feedback.append(element('strong', '', correct ? t.correct : t.incorrect), element('p', '', (correct ? '' : q.choices[q.answer] + '. ') + q.explanation));
        });
        grid.append(b);
      });
      content.append(question, grid, feedback);
    }
    const bar = element('nav', 'be-bar');
    bar.setAttribute('aria-label', 'Article engagement');
    const like = button('', 'be-action be-like');
    const key = 'blog-liked:' + path;
    let liked = false;
    try { liked = localStorage.getItem(key) === '1'; } catch (_) {}
    function showLike() { like.textContent = (liked ? '♥ ' : '♡ ') + (liked ? t.liked : t.like); like.setAttribute('aria-pressed', String(liked)); }
    showLike();
    like.addEventListener('click', () => {
      liked = !liked;
      let persistent = true;
      try { if (liked) localStorage.setItem(key, '1'); else localStorage.removeItem(key); } catch (_) { persistent = false; }
      showLike();
      status.textContent = persistent ? (liked ? t.deviceLiked : t.deviceUnliked) : t.temporaryLike;
    });
    bar.append(like);
    function menu(label) {
      const details = element('details', 'be-menu');
      details.append(element('summary', 'be-action', label));
      const panel = element('div', 'be-menu-panel');
      details.append(panel);
      details.addEventListener('toggle', () => { if (details.open) bar.querySelectorAll('details').forEach(other => { if (other !== details) other.open = false; }); });
      bar.append(details);
      return { details, panel };
    }
    const follow = menu('☆ ' + t.follow);
    const subscribe = button(t.newsletter, 'be-link');
    subscribe.addEventListener('click', () => {
      const inline = root.querySelector('.be-newsletter-panel');
      if (inline) inline.hidden = false;
      const email = inline ? inline.querySelector('input[type="email"]') : document.querySelector('input[name="contact[email]"], input[name="nl_email"]');
      follow.details.open = false;
      status.textContent = email ? t.newsletterHelp : t.newsletterMissing;
      if (email) { email.scrollIntoView({ behavior: 'smooth', block: 'center' }); email.focus({ preventScroll: true }); }
    });
    follow.panel.append(subscribe);
    (config.socials || []).forEach(s => follow.panel.append(link(s.label, s.url)));
    const share = menu('↗ ' + t.share);
    share.panel.append(link(t.facebook, 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url)));
    share.panel.append(link(t.linkedin, 'https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(url)));
    share.panel.append(link(t.email, 'mailto:?subject=' + encodeURIComponent(title) + '&body=' + encodeURIComponent(url)));
    const copy = button(t.copy, 'be-link');
    const manual = element('input', 'be-copy-input');
    manual.value = url;
    manual.readOnly = true;
    manual.hidden = true;
    manual.setAttribute('aria-label', t.link);
    copy.addEventListener('click', async () => {
      try { if (!navigator.clipboard || !navigator.clipboard.writeText) throw Error(); await navigator.clipboard.writeText(url); status.textContent = t.copied; }
      catch (_) { manual.hidden = false; manual.focus(); manual.select(); status.textContent = t.copyManual; }
    });
    share.panel.append(copy, manual);
    if (navigator.share) {
      const native = button(t.shareDevice, 'be-link');
      native.addEventListener('click', async () => { try { await navigator.share({ title, url }); } catch (error) { if (error.name !== 'AbortError') { manual.hidden = false; manual.focus(); manual.select(); status.textContent = t.copyManual; } } });
      share.panel.append(native);
    }
    const google = link('G ' + t.add, 'https://www.google.com/preferences/source?q=' + encodeURIComponent(config.domain || location.hostname));
    google.className = 'be-action be-google';
    google.title = t.google;
    google.setAttribute('aria-label', t.google);
    bar.append(google);
    root.append(bar, status);
  }
  function start() {
    if (location.hostname.endsWith('clipstrip.com') && document.querySelector('.blog-post-content') && !document.querySelector('[data-blog-engagement]')) {
      const root = document.createElement('div');
      root.className = 'blog-engagement';
      root.dataset.blogEngagement = '';
      root.dataset.config = JSON.stringify({ domain: 'clipstrip.com', socials: [{ label: 'Facebook', url: 'https://www.facebook.com/clipstrip/' }, { label: 'LinkedIn', url: 'https://www.linkedin.com/company/clip-strip-corp/' }] });
      document.querySelector('.blog-post-content').after(root);
    }
    document.querySelectorAll('[data-blog-engagement]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();
